import { render, staticRenderFns } from "./Congrats.vue?vue&type=template&id=e33a57c8&scoped=true&"
import script from "./Congrats.vue?vue&type=script&lang=js&"
export * from "./Congrats.vue?vue&type=script&lang=js&"
import style0 from "./Congrats.vue?vue&type=style&index=0&id=e33a57c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e33a57c8",
  null
  
)

export default component.exports